import {Component, inject, OnInit, signal} from '@angular/core';
import {MaterialModule} from '../../../../core/modules/material.module';
import {SharedModule} from '../../../../core/modules/shared.module';
import {PagesContainerComponent} from '../../pages-container/pages-container.component';
import {ForumTalkService} from '../../../../core/services/forumTalk.service';
import {MatDialog} from '@angular/material/dialog';
import {EditContentModal} from '../edit-forum-content/edit-content.modal';
import moment from 'moment';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-system-text',
  templateUrl: './system-text.component.html',
  styleUrls: ['./system-text.component.scss'],
  standalone: true,
  imports: [MaterialModule, SharedModule, PagesContainerComponent],
  providers: [ForumTalkService]
})

export class SystemTextComponent implements OnInit {
  private forumTalkService = inject(ForumTalkService);
  private dialog = inject(MatDialog);

  systemTexts = signal<any>([]);

  constructor() {
  }

  ngOnInit() {
    this.getSystemTexts();
  }

  getSystemTexts() {
    this.forumTalkService.getSystemTexts().subscribe((res: any) => {
      this.systemTexts.set(res);
    });
  }

  addSystemText() {
    const dialogRef = this.dialog.open(EditContentModal, {
      width: '600px',
      data: {header: 'forumTalk.add_system_text', type: 'systemText'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          data: result.data,
          type: result.type,
        };
        this.forumTalkService.addSystemText(data).subscribe((res: any) => {
          this.getSystemTexts();
        });
      }
    });
  }

  editSystemText(systemText: any) {
    const dialogRef = this.dialog.open(EditContentModal, {
      width: '600px',
      data: {header: 'forumTalk.edit_system_text', type: 'systemText', data: systemText}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          data: result.data,
          type: result.type,
        };
        this.forumTalkService.updateSystemText(systemText.id, data).subscribe((res: any) => {
          this.getSystemTexts();
        });
      }
    });
  }

  deleteSystemText(systemText) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      panelClass: 'unsave-form-dialog',
      width: '300px',
      data: {title: 'Delete', message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.forumTalkService.deleteSystemText(systemText.id).subscribe((res: any) => {
          this.getSystemTexts();
        });
      }
    });
  }
}
